"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Dialog_1 = tslib_1.__importDefault(require("@mui/material/Dialog"));
const LinearProgress_1 = tslib_1.__importDefault(require("./../LinearProgress"));
const DialogErrorBoundary_1 = tslib_1.__importDefault(require("./DialogErrorBoundary"));
/**
 *
 * A base implementation of a dialog component.
 * It extends the @mui/material and provides
 * a loading property
 *
 * @example ### Complete dialog
 *
 * This examples shows a complete dialog setup including all subcomponents
 *
 * ```jsx live noInline
 * file://./__examples__/1_BasicDialog.jsx
 * ```
 *
 */
const Dialog = (props, ref) => {
    const { children, LinearProgressProps: LinearProgressPropsProp = {}, loading = false, LinearProgressComponent = LinearProgress_1.default, ...rest } = props;
    const linearProgressProps = {
        loading,
        ...LinearProgressPropsProp,
    };
    return (react_1.default.createElement(Dialog_1.default, { fullWidth: true, ...rest, ref: ref },
        react_1.default.createElement(DialogErrorBoundary_1.default, null,
            react_1.default.createElement(LinearProgressComponent, { ...linearProgressProps }),
            children)));
};
exports.Dialog = Dialog;
const DialogWithRef = react_1.default.forwardRef(exports.Dialog);
if (process.env.NODE_ENV !== "production") {
    // @ts-ignore: Exposed for test purposes
    DialogWithRef.Naked = exports.Dialog;
}
exports.default = DialogWithRef;
